/**
 * Control panel with analysis button and status
 */

import { LoadingState } from '../types/index';

interface ControlPanelProps {
  onAnalyze: () => void;
  loading: LoadingState;
  error: string | null;
  dataCount: number;
}

export function ControlPanel({
  onAnalyze,
  loading,
  error,
  dataCount,
}: ControlPanelProps) {
  return (
    <div className="bg-white rounded-lg shadow-md border border-slate-200 p-6 mb-6">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex-1 min-w-64">
          <button
            onClick={onAnalyze}
            disabled={loading.isLoading}
            className={`w-full px-6 py-3 font-semibold rounded-lg transition-all ${
              loading.isLoading
                ? 'bg-gray-400 cursor-not-allowed text-white'
                : 'bg-hive hover:bg-red-700 text-white shadow-md hover:shadow-lg'
            }`}
          >
            {loading.isLoading ? (
              <span className="flex items-center justify-center gap-2">
                <span className="animate-spin inline-block h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
                {loading.currentStep}
              </span>
            ) : (
              '🔍 Start Analysis'
            )}
          </button>
        </div>

        <div className="text-right">
          {loading.isLoading && (
            <div className="mb-2">
              <div className="w-32 h-2 bg-slate-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-hive transition-all duration-300"
                  style={{ width: `${loading.progress}%` }}
                ></div>
              </div>
              <p className="text-xs text-slate-600 mt-1">{loading.progress}%</p>
            </div>
          )}
          {dataCount > 0 && !loading.isLoading && (
            <p className="text-sm text-slate-600">
              ✅ <span className="font-semibold">{dataCount}</span> posts analyzed
            </p>
          )}
        </div>
      </div>

      {error && (
        <div className="mt-4 p-4 bg-red-50 border-l-4 border-red-500 rounded text-red-800">
          <p className="font-semibold text-lg">⚠️ Error</p>
          <p className="text-sm mt-2 whitespace-pre-wrap">{error}</p>
          <p className="text-xs mt-3 text-red-600">💡 Tip: Open browser console (F12) for detailed debugging information</p>
        </div>
      )}

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm text-slate-600">
        <div>
          <p className="font-semibold text-slate-700">HIVE RPC</p>
          <p className="text-xs">api.hive.blog</p>
        </div>
        <div>
          <p className="font-semibold text-slate-700">Steemit RPC</p>
          <p className="text-xs">api.steemit.com</p>
        </div>
        <div>
          <p className="font-semibold text-slate-700">Blurt RPC</p>
          <p className="text-xs">rpc.blurt.world</p>
        </div>
      </div>
    </div>
  );
}
